import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getFolders(data) {
    return request.get(`/${platform}/local_materials/folders`,data)
}

export function getMaterials(data) {
    return request.get(`/${platform}/local_materials`,data)
}

export function storeOrUpdateMaterial(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/local_materials/${data.id}` : `/${platform}/local_materials`;
    return request[method](url, data)
}

export function deleteMaterial(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/local_materials/${ids}`)
}

export function getMediaRecords(data) {
    return request.get(`/${platform}/local_materials/media_record`,data)
}

export function uploadToMedia(data) {
    return request.post(`/${platform}/local_materials/upload_to_media`,data)
}

export function importMaterial(data) {
    const method = 'post'
    const url =  `/${platform}/local_materials/import`;
    return request[method](url, data)
}

export function showTasks(data) {
    return request.get(`/${platform}/local_materials/show_task`, data)
}

export function zmTask(data) {
    return request.post(`/${platform}/local_materials/zm_task`,data)
}

export function clearFolders(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.post(`/${platform}/local_materials/clear_folders/${ids}`)
}

export function createAdTask(data) {
    const url = `/${platform}/local_materials/create_ad_task`
    return request.post(url, data)
}

export function batchUploadMaterial(data) {
    return request.post(`/${platform}/local_materials/batch_upload`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function getPushRecords(data) {
    return request.get(`/${platform}/local_materials/push_record_list`, data)
}

export function retryPushRecords(data) {
    return request.post(`/${platform}/local_materials/push_record_retry`, data)
}
